const TAG_NAME = 'shopify-planner-helper';

if (!window.customElements.get(TAG_NAME)) {
    class ShopifyPlannerHelper extends HTMLElement {
        constructor() {
            super();

            this._setupListeners();
            this._init();
        }

        _init() {
            const frameUrl = new URL('https://modulbygger.fdbmobler.dk/dk'); // CHANGE THIS
            const searchParams = new URL(window.location).searchParams;
            const config = searchParams.get('config');

            if (config) {
                frameUrl.searchParams.append('config', config);
            }

            const family = searchParams.get('family');

            if (family) {
                frameUrl.searchParams.append('family', family);
            }

            frameUrl.searchParams.append('iframe', '1');

            this._setFrameUrl(frameUrl.toString());
        }

        _setFrameUrl(url) {
            const frame = this.querySelector('iframe');

            if (!frame) {
                return;
            }

            frame.src = url;
        }

        _setupListeners() {
            window.addEventListener('message', this._onMessageEvent.bind(this));
        }

        _onMessageEvent(event) {
            if (!event.data?.type) {
                return;
            }

            switch (event.data.type) {
                case 'cart:submit':
                    return this._onCartSubmit(event);
            }
        }

        async _onCartSubmit(event) {
            const items = event.data.detail.items.map(item =>
                this._toIdQtySet(item, event.data.detail.configuration)
            );

            await this._addToCart(items);

            const cartContent = await this._getCart();

            this.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items, cart: cartContent }
            }));
            document.querySelector('cart-drawer')?.show();

            await this._refreshCartDrawerViaSections('variant:add');
        }

        _getLocaleAwareUrlRoot(path = '') {
            return (window?.Shopify?.routes?.root || '/') + path;
        }

        _addToCart(items) {
            return fetch(this._getLocaleAwareUrlRoot('cart/add.js'), {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items })
            }).then(r => r.json());
        }

        async _getCart() {
            const res = await fetch(this._getLocaleAwareUrlRoot('cart.js'), { credentials: 'same-origin' });
            return res.json();
        }

        _toIdQtySet(item, configuration) {
            if (!item.variant_id) {
                throw new Error('variant_id not found: Planner is most likely not using ShopifyCheckout or a product is missing a variant_id.');
            }
            return {
                id: item.variant_id,
                quantity: item.quantity,
                properties: {
                _planner_code: configuration.code // IMPORTANT FOR ORDER CONVERSION TRACKING
                }
            };
        }

        async _refreshCartDrawerViaSections(baseEvent = 'variant:add') {
            const sections = [];
            document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
                bubbles: true,
                detail: { sections }
            }));
            if (!sections.length) return;

            const res = await fetch(
                `${this._getLocaleAwareUrlRoot()}cart?sections=${encodeURIComponent(sections.join(','))}`,
                { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }
            );
            const sectionsHtml = await res.json();

            const cartJson = await this._getCart();

            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                baseEvent,
                cart: {
                    item_count: cartJson.item_count,
                    sections: sectionsHtml
                }
                }
            }));
        }
    }

  window.customElements.define(TAG_NAME, ShopifyPlannerHelper);
}